import React, { useState } from 'react'
import { UsuarioModel } from './models/UsuarioModel'
import { Util } from './components/Util'
import { useAuthState } from './stores/authStore'

let _timeout: any

const useGlobalStore = () => {
  const { usuario: authUsuario } = useAuthState()
  const [message, _setMessage] = useState({ show: false, message: '', type: 'error' })
  const [isLoading, setIsLoading] = useState(false)
  const [firstPage] = useState('/inicio')

  function closeMessage() {
    _setMessage({ ...message, show: false })
  }

  function setErrorMessage(m: string, timeToHide: number = 3000) {
    if (message.message === m && message.show) Util.confirm(m)
    _setMessage({ type: 'error', message: m, show: true })
    if (timeToHide) _hideMessage(timeToHide)
  }
  function setInfoMessage(m: string, timeToHide: number = 3000) {
    _setMessage({ type: 'info', message: m, show: true })
    if (timeToHide) _hideMessage(timeToHide)
  }
  function setSuccessMessage(m: string, timeToHide: number = 3000) {
    _setMessage({ type: 'success', message: m, show: true })
    if (timeToHide) _hideMessage(timeToHide)
  }

  function _hideMessage(timeToHide: number) {
    if (_timeout) clearTimeout(_timeout)
    _timeout = setTimeout(() => _setMessage({ ...message, show: false }), timeToHide)
  }

  const usuario = (authUsuario ?? {}) as UsuarioModel

  return {
    usuario,
    message,
    closeMessage,
    setErrorMessage,
    setInfoMessage,
    setSuccessMessage,
    isLoading,
    setIsLoading,
    firstPage,
  }
}
export type GlobalStoreValues = ReturnType<typeof useGlobalStore>
export const GlobalStoreCtx = React.createContext(null)
export const GlobalStore = (props: any) => {
  const values = useGlobalStore()
  return <GlobalStoreCtx.Provider value={values}>{props.children}</GlobalStoreCtx.Provider>
}
